import React, { useRef } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import breakpoint from "styled-components-breakpoint";
import Link from "@nib-components/link";
import { Margin, Padding } from "styled-components-spacing";
import { Stack, Column, Columns, Box } from "@nib/layout";
import Heading from "@nib-components/heading";

import videoPoster from "./images/video_poster_laptop_image.jpg";
import Container from "@nib-components/container";
import useWindowDimensions from "../../utils/breakpoints";
import colors from "@nib-components/colors";
import { colorWarmWhite60 } from "@nib-components/theme";

const StyledHeading = styled(Heading)`
  text-align: left;
  ${breakpoint("md")`
    text-align: left;
  `}
`;

const StyledVideo = styled.video`
  width: 100%;
`;

const StyledDiv = styled.div`
  background-color: ${colorWarmWhite60};

  ${breakpoint("lg")`
  background-color: ${colorWarmWhite60};
  `};
`;

const ProductOverview = ({ content, onClick }) => {
  const { text, title: subTitle } = content;
  const scrollRef = useRef();
  const { isMobile } = useWindowDimensions();
  return (
    <StyledDiv id="product-overview">
      <Padding vertical={{ xs: 7, md: 8, lg: 0 }}>
        <Padding vertical={{ lg: 9 }}>
          <Container>
            <Padding horizontal={{ xs: 4, md: 6, lg: 8 }}>
              {/* start product sell point (what will I learn?) */}
              <Columns space={{ xs: 4, lg: 7 }} collapseBelow="lg" reverse={isMobile}>
                <Column width={{ xs: 1, lg: "1/2" }}>
                  {/* <Margin left={{ xs: 0, lg: 8 }}> */}
                  <Stack space={{ xs: 1, md: 4 }}>
                    <Margin top={{ xs: 5 }}>
                      <div ref={scrollRef}>
                        <StyledHeading component="h3" size={{ xs: 3, md: 2 }}>
                          {subTitle}
                        </StyledHeading>
                      </div>
                    </Margin>
                    {text.length &&
                      text.map((item, index) => (
                        <Margin top={4} key={index}>
                          <p>{item}</p>
                        </Margin>
                      ))}
                    <Margin>
                      <Link href="javascript:;" onClick={onClick}>
                        Read more about what&apos;s covered in the course modules.
                      </Link>
                    </Margin>
                  </Stack>
                  {/* </Margin> */}
                </Column>
                <Column width={{ xs: 1, lg: "1/2" }} style={{ alignSelf: "center" }}>
                  <Box>
                    <StyledVideo controls poster={videoPoster}>
                      <source
                        type="video/mp4"
                        src="https://player.vimeo.com/external/301564964.hd.mp4?s=df082c2ed9e40cca62191ff8f95824e241a95de5&profile_id=175"
                      />
                      <p>
                        Your browser doesn&apos;t support HTML5 video. Here is a{" "}
                        <Link href="https://vimeo.com/301564964">Link</Link>
                      </p>
                    </StyledVideo>
                  </Box>
                </Column>
              </Columns>
            </Padding>
            {/* end product sell point (what will I learn?) */}
          </Container>
        </Padding>
      </Padding>
    </StyledDiv>
  );
};

ProductOverview.propTypes = {
  content: PropTypes.shape({
    contentType: PropTypes.string,
    cta: PropTypes.arrayOf(
      PropTypes.shape({
        copy: PropTypes.string,
        title: PropTypes.string,
      })
    ),
    items: PropTypes.arrayOf(PropTypes.string),
    title: PropTypes.string,
    text: PropTypes.arrayOf(PropTypes.string),
  }),
  image: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
  }),
};

export default ProductOverview;
